<template>
  <v-group :config="{ listening: false }">
    <v-line
      v-for="index in maxHorizCount"
      :key="`vert-${index}`"
      :config="{
        points: [index * GRID_UNIT_PX, 0, index * GRID_UNIT_PX, dimensions.height],
        stroke: STROKE_COLOR,
        strokeWidth: STROKE_WIDTH
      }"
    />
    <v-line
      v-for="index in maxVertCount"
      :key="`horiz-${index}`"
      :config="{
        points: [0, index * GRID_UNIT_PX, dimensions.width, index * GRID_UNIT_PX, ],
        stroke: STROKE_COLOR,
        strokeWidth: STROKE_WIDTH
      }"
    />
  </v-group>
</template>

<script>
import { GRID_UNIT_PX } from '@/constants';

const STROKE_COLOR = 'black';
const STROKE_WIDTH = 0.1;

export default {
  name: 'PlaygroundGrid',
  props: {
    dimensions: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      GRID_UNIT_PX,
      STROKE_COLOR,
      STROKE_WIDTH,
    };
  },
  computed: {
    maxHorizCount() {
      return Math.ceil((this.dimensions.width) / GRID_UNIT_PX);
    },
    maxVertCount() {
      return Math.ceil((this.dimensions.height) / GRID_UNIT_PX);
    },
  },
};
</script>
